import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import MediaMarquee from "@/components/MediaMarquee";
import AboutSection from "@/components/AboutSection";
import LeadMagnetSection from "@/components/LeadMagnetSection";
import FuturePathSection from "@/components/FuturePathSection";
import BookSection from "@/components/BookSection";
import CommunitySection from "@/components/CommunitySection";
import VideosSection from "@/components/VideosSection";
import SpeakingSection from "@/components/SpeakingSection";
import SpeakingForm from "@/components/SpeakingForm";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function HomePage() {
  return (
    <main className="min-h-screen bg-background">
      <Navigation />
      <HeroSection />
      <MediaMarquee />
      <AboutSection />
      <VideosSection />
      <LeadMagnetSection />
      <FuturePathSection />
      <BookSection />
      <SpeakingSection />
      <SpeakingForm />
      <CommunitySection />
      <ContactSection />
      <Footer />
    </main>
  );
}
